export namespace StorageKeys {
  export const SESSION_TOKEN = 'io.density.oa.token';
  export const CSV_TASK_ID = 'io.density.oa.csv-task';
  export const CSV_S3_URL = 'io.density.oa.csv-s3-url';
  // unique key to know if other CSV keys are stale
  export const CSV_KEY = 'io.density.oa.csv-key';
}
